import React from 'react';
import { Datagrid, TextField } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import FullNameField from '../components/FullNameField';
// import RoleReferenceField from './RoleReferenceField';
import OrganizationReferenceField from '../organizations/OrganizationReferenceField';
import rowStyle from '../components/rowStyle';

const useListStyles = makeStyles({
    headerRow: {
        borderLeftColor: 'white',
        borderLeftWidth: 5,
        borderLeftStyle: 'solid',
    },
    comment: {
        maxWidth: '18em',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
});

const RoleTypeField = props => {
    if (!props.record) return <></>;
    let roles = '';
    if (props.record.invoiceValidator) {
        roles += '🧾';
    }
    if (props.record.invoiceCreator) {
        roles += '📤';
    }
    if (props.record.orderValidator) {
        roles += '📝';
    }
    if (props.record.ticketValidator) {
        roles += '🎫';
    }
    if (props.record.ticketAdmin) {
        roles += '🔏';
    }
    if (props.record.supplierValidator) {
        roles += '👮';
    }
    if (props.record.issueManager) {
        roles += '🛰';
    }
    return <>{roles}</>
};

const UserListDesktop = props => {
    const classes = useListStyles();
    return (
        <Datagrid
            rowClick="edit"
            rowStyle={rowStyle}
            classes={{ headerRow: classes.headerRow }}
            optimized
            {...props}
        >
            <FullNameField />
            <TextField source="email" />
            <OrganizationReferenceField />
            <TextField source="role.name" label="resources.users.fields.role"/>
            <RoleTypeField />
        </Datagrid>
    );
};

export default UserListDesktop;
